import { useState } from 'react'
import { useWebContent } from '../lib/webPrices'
import { apiUrl } from '../lib/api'

/** Mapa Google až po kliknutí (5. 11. 2026) — bez kliknutí web Googlu nic nepošle, takže nepotřebuje lištu cookies. */
function MapOnClick() {
  const [show, setShow] = useState(false)
  const Q = '49.6993,17.0312'
  if (show) {
    return (
      <div className="aspect-[4/3] bg-ink-900/5 rounded-2xl overflow-hidden">
        <iframe title="Mapa Sobáčov 111" src={`https://maps.google.com/maps?q=${Q}&z=15&hl=cs&output=embed`}
          className="w-full h-full border-0" referrerPolicy="no-referrer-when-downgrade" />
      </div>
    )
  }
  return (
    <div className="aspect-[4/3] rounded-2xl overflow-hidden relative bg-forest-50 border border-ink-900/10 flex flex-col items-center justify-center text-center px-6">
      <svg viewBox="0 0 24 24" className="w-10 h-10 text-brand-500" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z" /><circle cx="12" cy="9.5" r="2.5" />
      </svg>
      <div className="mt-3 font-semibold text-ink-900">Sobáčov 111, 783 21 Mladeč</div>
      <div className="mt-1 text-xs text-ink-700 max-w-xs">Mapa se načte ze služby Google Maps až po kliknutí. Google přitom zpracuje vaši IP adresu.</div>
      <div className="mt-4 flex flex-wrap justify-center gap-2">
        <button type="button" onClick={() => setShow(true)} className="btn-book !px-5 !py-2 !text-[14px]">Zobrazit mapu</button>
        <a href={`https://mapy.cz/zakladni?q=${Q}&z=15`} target="_blank" rel="noopener noreferrer"
          className="inline-flex items-center px-5 py-2 text-[14px] font-semibold rounded-[10px] border border-ink-900/20 hover:border-brand-500 hover:text-brand-600">
          Otevřít v Mapy.cz ↗
        </a>
      </div>
    </div>
  )
}

function ContactHours() {
  const content = useWebContent()
  const lines = ((content.contact_hours as string) || 'květen – říjen\nSt–Čt 14:00 · Pá–Ne 9:00').split('\n')
  return (
    <div>
      <div className="text-[11px] uppercase tracking-[0.14em] text-ink-700/70 font-semibold">Otevřeno</div>
      <div className="mt-1.5 font-semibold">{lines[0]}</div>
      {lines[1] && <div className="text-ink-700 text-xs">{lines[1]}</div>}
    </div>
  )
}

export function Contact() {
  const [form, setForm] = useState({ name: '', phone: '', email: '', message: '' })
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState(false)
  const [err, setErr] = useState<string | null>(null)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    setErr(null)
    try {
      const r = await fetch(apiUrl('/api/sobacov/contact/public'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      })
      if (!r.ok) {
        const j = await r.json().catch(() => ({}))
        throw new Error(j.detail || 'Nepodařilo se odeslat')
      }
      setDone(true)
    } catch (e: any) {
      setErr(e.message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <section id="kontakt" className="py-20 md:py-28 bg-paper">
      <div className="container-x">
        <div className="max-w-3xl">
          <p className="h-eyebrow">Kontakt</p>
          <h2 className="h-display text-3xl md:text-[44px] mt-4">Napište nám</h2>
          <p className="mt-5 text-ink-700 text-base md:text-lg">
            Rezervace, dotazy ohledně cateringu, brigád nebo akce na klíč.
          </p>
        </div>

        <div className="mt-12 grid lg:grid-cols-2 gap-10 lg:gap-16">
          {/* Mapa + kontaktní info */}
          <div>
            <MapOnClick />
            <div className="mt-6 grid sm:grid-cols-2 gap-5 text-ink-800 text-sm">
              <div>
                <div className="text-[11px] uppercase tracking-[0.14em] text-ink-700/70 font-semibold">Adresa</div>
                <div className="mt-1.5 font-semibold">Sportovní areál Sobáčov</div>
                <div>Sobáčov 111, 783 21 Mladeč</div>
              </div>
              <div>
                <div className="text-[11px] uppercase tracking-[0.14em] text-ink-700/70 font-semibold">Telefon</div>
                <a href="tel:+420775140705" className="block mt-1.5 font-semibold hover:text-brand-500">
                  +420 775 140 705
                </a>
                <div className="text-ink-700 text-xs">recepce penzionu</div>
                <a href="tel:+420775433401" className="block mt-2 font-semibold hover:text-brand-500">
                  +420 775 433 401
                </a>
                <div className="text-ink-700 text-xs">rybolov · chatky · sport</div>
              </div>
              <div>
                <div className="text-[11px] uppercase tracking-[0.14em] text-ink-700/70 font-semibold">E-mail</div>
                <a
                  href="mailto:rezervace.sobacov@gmail.com"
                  className="block mt-1.5 font-semibold hover:text-brand-500 break-all"
                >
                  rezervace.sobacov@gmail.com
                </a>
              </div>
              <ContactHours />
            </div>
          </div>

          {/* Formulář */}
          <form onSubmit={submit} className="card p-7 md:p-9">
            {done ? (
              <div className="text-center py-10">
                <svg viewBox="0 0 24 24" className="w-12 h-12 mx-auto mb-3 text-brand-500" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 12.5l5 5L20 6.5" />
                </svg>
                <div className="font-semibold text-xl text-ink-900">Odesláno!</div>
                <p className="text-ink-700 mt-2 text-sm">Ozveme se vám v nejbližší době.</p>
              </div>
            ) : (
              <div className="space-y-4">
                <div className="grid sm:grid-cols-2 gap-4">
                  <Field label="Jméno *" value={form.name} onChange={(v) => setForm({ ...form, name: v })} required />
                  <Field label="Telefon" value={form.phone} onChange={(v) => setForm({ ...form, phone: v })} />
                </div>
                <Field label="E-mail *" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} required />
                <label className="block">
                  <span className="text-[11px] uppercase tracking-[0.14em] text-ink-700/70 font-semibold">Zpráva</span>
                  <textarea
                    value={form.message}
                    onChange={(e) => setForm({ ...form, message: e.target.value })}
                    rows={5}
                    className="mt-1.5 w-full border border-ink-900/15 rounded-lg px-3 py-2 text-ink-800 focus:outline-none focus:border-brand-500"
                  />
                </label>
                {err && <div className="mt-3 text-brand-500 text-sm">{err}</div>}
                <button type="submit" disabled={busy} className="btn-book w-full mt-5">
                  {busy ? 'Odesílám…' : 'Odeslat zprávu'}
                </button>
                <p className="mt-3 text-[11px] text-ink-700">
                  Odesláním souhlasíte se zpracováním osobních údajů pouze pro vyřízení vašeho
                  dotazu — podrobnosti v{' '}
                  <a href="#gdpr" className="underline hover:text-brand-600">zásadách zpracování osobních údajů</a>.
                </p>
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  )
}

function Field({
  label,
  value,
  onChange,
  type = 'text',
  required,
}: {
  label: string
  value: string
  onChange: (v: string) => void
  type?: string
  required?: boolean
}) {
  return (
    <label className="block">
      <span className="text-[11px] uppercase tracking-[0.14em] text-ink-700/70 font-semibold">{label}</span>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className="mt-1.5 w-full border border-ink-900/15 rounded-lg px-3 py-2 text-ink-800 focus:outline-none focus:border-brand-500"
      />
    </label>
  )
}
